import { create } from "zustand";

export type SyncStatus = "idle" | "syncing" | "synced" | "offline" | "error";

interface SyncStatusState {
  status: SyncStatus;
  lastSyncedAt: string | null;
  setStatus: (status: SyncStatus) => void;
  setSynced: () => void;
}

export const useSyncStatusStore = create<SyncStatusState>((set) => ({
  status: "idle",
  lastSyncedAt: null,
  setStatus: (status) => set({ status }),
  setSynced: () => set({ status: "synced", lastSyncedAt: new Date().toISOString() }),
}));
